import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GuestData } from 'types';

export type GuestAuthStore = {
  guestInfo: GuestData | null;
};

const initialState: GuestAuthStore = {
  guestInfo: null
};

export const persistGuestAuthSlice = createSlice({
  name: 'persistGuestAuth',
  initialState,
  reducers: {
    setGuestInfo: (state, action: PayloadAction<GuestData | null>) => {
      state.guestInfo = action.payload;
    },
    updateGuestZip: (state, action: PayloadAction<string>) => {
      if (state.guestInfo) {
        state.guestInfo.zip = action.payload;
      }
    },
    clearGuestInfo: (state) => {
      state.guestInfo = null;
    }
  }
});

export const { setGuestInfo, updateGuestZip, clearGuestInfo } =
  persistGuestAuthSlice.actions;

export default persistGuestAuthSlice.reducer;
